import { isXiaolaChannelFn } from '@/constant/commodity';
import type { BillDetailType, OrderDetailInfoType } from '@/pages/order-center-order-detail/type';
import { useState, useCallback, useMemo } from 'react';

type EventType = 1 | 3;
type DriverRoleTextType = '司机' | '骑手';

export default function OrderCenterOrderDetailOrderStatus() {
  const [eventType, setEventType] = useState<EventType>(1); // 1 默认事件 3 修改了小费
  const [waitReplyDriverConfig, setWaitReplyDriverConfig] = useState<any>({}); // 获取播单司机接口数据-轮询更新
  const [addFeeOrderList, setAddFeeOrderList] = useState<string[]>([]); // 将加过小费的订单 缓存起来。
  const [driverRoleText, setDriverRoleText] =
    useState<DriverRoleTextType>('司机'); // 司机 ｜ 骑手
  const [isFamiliarFreight, setIsFamiliarFreight] = useState<boolean>(false); // 是否熟车客运

  const [orderDetail, setOrderDetail] = useState<OrderDetailInfoType>();

  const [billDetail, setBillDetail] = useState<BillDetailType>();

  const setWaitReplyDriverConfigCb = useCallback((val) => {
    setWaitReplyDriverConfig(val);
  }, []);
  const setEventTypeCb = useCallback((val) => {
    setEventType(val);
  }, []);
  const setAddFeeOrderListCb = useCallback((val) => {
    setAddFeeOrderList(val);
  }, []);

  const updateOrderDetail = useCallback(
    (val: OrderDetailInfoType) => {
      setOrderDetail(val);
    },
    [setOrderDetail]
  );


  // 小拉聚合渠道
  const isXiaolaChannel = useMemo(() => {
    return isXiaolaChannelFn(orderDetail?.commodityInfo?.commodity?.agrChannel);
  }, [orderDetail?.commodityInfo?.commodity?.agrChannel])

  const isXiaolaDriver = useMemo(() => { return orderDetail?.driverInfo?.driverType === 8 }, [orderDetail?.driverInfo?.driverType])


  // const 
  return {
    eventType,
    waitReplyDriverConfig,
    addFeeOrderList,
    setEventTypeCb,
    setWaitReplyDriverConfigCb,
    setAddFeeOrderListCb,
    driverRoleText,
    setDriverRoleText,
    isFamiliarFreight,
    setIsFamiliarFreight,
    orderDetail,
    updateOrderDetail,
    /** 小拉聚合渠道 */
    isXiaolaChannel,
    /** 小拉司机 */
    isXiaolaDriver,

    billDetail,
    setBillDetail,
  };
}
